import React from 'react';
import { connect } from 'react-redux';
import { AlTemplateTherActRow } from 'PatientCareCenter/Note/AL/Templates';
import styles from './Common.module.css';


class AlTemplateTherAct extends React.Component {

    render() {
        if (this.props.activities.length > 0) {
            return (
                <div className={styles.section_wrapper}>
                    <div className={styles.header_row}>Therapeutic Activities (97530)</div>

                    {Object.keys(this.props.activities)
                        .map(key => {
                            const result = this.props.activities[key];
                            return (
                                <AlTemplateTherActRow key={result.XLTMPTANO} id={result.XLTMPTANO} />
                            )
                        })
                    }
                </div>
            );
        } else {
            return (<span />);
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;

    return {
        activities: state.entities.notes.MLTMPTHERACT ?
            Object.keys(state.entities.notes.MLTMPTHERACT)
                .filter(key => {
                    return (state.entities.notes.MLTMPTHERACT[key].NoteId === noteId)
                })
                .sort((a, b) => state.entities.notes.MLTMPTHERACT[a].XLTMPTAORDER - state.entities.notes.MLTMPTHERACT[b].XLTMPTAORDER)
                .map(key => state.entities.notes.MLTMPTHERACT[key]) : [],
    };
}

const connectedAlTemplateTherAct = connect(mapStateToProps)(AlTemplateTherAct);
export { connectedAlTemplateTherAct as AlTemplateTherAct };

